import React, {Component} from 'react';
import ReactHtmlParser from 'react-html-parser';
import classNames from 'classnames';
import RepostButtons from '../../common/view/RepostButtons';
import {companyActions} from '../../../actions/companyActions';
import '../../../../scss/job-view.scss';

class JobViewPage extends React.Component {
    constructor(props) {
        super(props);
    }

    static prependPrint() {
        let contentForPrint = document.getElementById("content-for-print");
        if (!contentForPrint) {
            return;
        }

        let footer = document.querySelector('footer.footer').cloneNode(true);

        contentForPrint = contentForPrint.cloneNode(true);
        document.querySelectorAll('link[type="text/css"]').forEach(function (linkElem) {
            let clonedNode = linkElem.cloneNode();
            contentForPrint.appendChild(clonedNode);
        });

        contentForPrint.appendChild(footer);

        let pri = document.getElementById("print-content").contentWindow;
        pri.document.open();
        pri.document.write(contentForPrint.outerHTML);

        pri.document.close();
    }

    static print(e) {
        e.preventDefault();

        let pri = document.getElementById("print-content").contentWindow;
        pri.focus();
        pri.print();

    }

    render() {
        let {
            job,
        } = this.props;

        return (
            <div>
                <div className="row job-preview-container">
                    <div className={classNames('col-md-8')}>
                        <h2 className="job-title">{`${job.title} / ${job.companyName}`}</h2>
                        <hr/>
                        <div className="row mt-4">
                            <div className="col-sm-12">
                                <figure><img className="company-preview-logo" src={`${job.logoUrl}?w=190&zc=2`}
                                             alt={job.companyName}/></figure>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                {ReactHtmlParser(job.content)}
                            </div>
                        </div>
                    </div>

                    <div className={classNames('col-md-4', 'job-preview-sidebar')}>

                        <div className="table-rep-plugin">
                            <div className="table-wrapper">
                                <div className="table-responsive b-0">
                                    <table className="table table-striped 'col-md-4">
                                        <tbody>
                                        <tr>
                                            <th>Firmanavn</th>
                                            <td>{job.companyName}</td>
                                        </tr>
                                        <tr>
                                            <th>Region</th>
                                            <td>{job.region}</td>
                                        </tr>
                                        <tr>
                                            <th>Kategori</th>
                                            <td>{job.category}</td>
                                        </tr>
                                        <tr>
                                            <th>Arbejdstid</th>
                                            <td>{job.workingTime}</td>
                                        </tr>
                                        {(job.created) ?
                                            <tr>
                                                <th>Dato for oprettelse</th>
                                                <td>{job.created}</td>
                                            </tr>
                                            : null
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="col-md-3">
                                    <a href onClick={JobViewPage.print} className="btn btn-md btn-primary">Udskriv</a>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="pull-right">
                                    <RepostButtons/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="content-for-print" className="mt-5">
                    <div className="row">
                        <div className="col-12">
                            <figure>
                                <img className="print-img company-preview-logo" src={`${job.logoUrl}?w=190&zc=2`}
                                     alt={job.companyName}/>
                            </figure>
                            <h3 className="mb-3">{job.companyName}</h3>
                            <table className="table">
                                <tbody>
                                <tr>
                                    <th>Firmanavn</th>
                                    <td>{job.companyName}</td>
                                </tr>
                                <tr>
                                    <th>Region</th>
                                    <td>{job.region}</td>
                                </tr>
                                <tr>
                                    <th>Kategori</th>
                                    <td>{job.category}</td>
                                </tr>
                                <tr>
                                    <th>Arbejdstid</th>
                                    <td>{job.workingTime}</td>
                                </tr>
                                {(job.created) ?
                                    <tr>
                                        <th>Dato for oprettelse</th>
                                        <td>{job.created}</td>
                                    </tr>
                                    : null
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12">
                            {ReactHtmlParser(job.content)}
                        </div>

                    </div>
                </div>
                <iframe id="print-content">
                </iframe>
            </div>

        );
    }

    componentDidMount() {
        JobViewPage.prependPrint();
    }

    componentDidUpdate() {
        JobViewPage.prependPrint();
    }
};

export default JobViewPage;


// WEBPACK FOOTER //
// ./web/src/components/jobs/view/JobViewPage.jsx